import React, { useState, useEffect, useContext } from 'react';
import { useParams, Link } from "react-router-dom";

import api from '../../Utils/Api';
import { CurrentUserContext } from '../../Contexts/CurrentUserContext';
import { JourneyContext } from '../../Contexts/JourneyContext'

import './Theme.css';

import LessonCard from '../App/Common/Cards/LessonCard/LessonCard';
import TaskCard from '../App/Common/Cards/TaskCard/TaskCard';
import TableTests from '../Performance/Tables/TableTests/TableTests';
import HorizontalTree from '../App/Common/HorizontalTree/HorizontalTree';
import OpenedBlock from '../App/Common/BlocksWithCards/OpenedBlock/OpenedBlock';
import Calendar from '../Calendar/Calendar';


const defaultData = [
    'Все уроки',
    'Актуальные задания',
    // 'Выполненные задания',
    'Успеваемость',
]

const Theme = () => {
    const { currentPlace, breadCrumbs, setBreadCrumbs, setCurrentPlace } = useContext(JourneyContext)
    const { token } = useContext(CurrentUserContext)

    let params = useParams();
    let selectedThemeId = parseInt(params.id)


    const [selectedTab, setSelectedTab] = useState(0)
    const [allDataReceived, setAllDataReceived] = useState(false)
    const [allLessons, setAllLessons] = useState(undefined)
    const [currentTests, setCurrentTests] = useState(undefined)
    const [testsDone, setTestsDone] = useState(undefined)
    const [performance, setPerformance] = useState(undefined)
    const [isLessonsOpened, setIsLessonsOpened] = useState(false)
    const [lessonSiblings, setLessonSiblings] = useState(undefined)
    const [isLessonChecked, setIsLessonChecked] = useState(false)
    const [checkedId, setCheckedId] = useState({ model: 'topic', id: selectedThemeId })


    useEffect(() => {
        Promise.all([api.getAllLessons(token, selectedThemeId), api.getCurrentTests(token, selectedThemeId), api.getPerformanceSpecial(token, 'topic', selectedThemeId)])

            .then(([allLessons, currentTests, performance]) => {
              //  console.log(allLessons)
            //   const updatedLessons = allLessons.lessons.map(lesson => {
            //     const filteredSteps = lesson.steps.filter(step => step.type !== 'videofile');
            //     return {
            //       ...lesson,
            //       steps: filteredSteps
            //     };
            //   });
              
            //   const updatedRes = {
            //     ...allLessons,
            //     lessons: updatedLessons
            //   };
              
            //   setAllLessons(updatedRes);
            const updateLessons = () => {
                const updatedLessons = allLessons.lessons.map(lesson => {
                  const filteredSteps = lesson.steps.filter(step => step.type !== 'videofile');
                  const totalSteps = filteredSteps.length; // Пересчитываем общее количество шагов
              
                  return {
                    ...lesson,
                    steps: filteredSteps,
                    total_steps: totalSteps // Обновляем total_steps
                  };
                });
              
                return updatedLessons;
              };
              
              const updatedLessons = updateLessons();
              setAllLessons(updatedLessons);
              

            //   setAllLessons(updatedAllLessons);
                // setAllLessons(allLessons.lessons)
               // console.log(currentTests)
                setCurrentTests(currentTests)
                // setTestsDone(testsDone)
                setPerformance(performance)
                setAllDataReceived(true)
                setLessonSiblings(allLessons.lessons)
                setBreadCrumbs(allLessons.parents)
                setCurrentPlace(allLessons.parents.slice(-1)[0])

            })
            .catch((e) => {
                console.log(e);
            });

            return () => {
                setBreadCrumbs([]);
            };
    }, []);
    // console.log(allLessons)
    // console.log(currentTests)
    // console.log(testsDone)
    // console.log(performance)




    const getTabTitle = (currentTab) => {
        switch (currentTab) {
            case 0:
                return 'Все уроки'
            case 1:
                return 'Актуальные задания'
            // case 2:
            //     return 'Выполненные задания'
            case 2:
                return 'Успеваемость'

            default:
                return ''
        }
    }
    const sortTable = (orderBy, orderType) => {
//         console.log(checkedId)
// console.log(orderBy)
// console.log(orderType)
        api.getPerformanceSpecialSorted(token, checkedId.model, checkedId.id, orderBy, orderType)
            .then((res) => {
                // console.log(res)
                setPerformance(res)

            })
            .catch((e) => {
                console.log(e);
            });

    }

    function disableScrolling() { 
        // setTimeout(function() { 
        //     document.body.style.overflow = 'hidden'; 
        // }, 1000); 
        console.log('scroll')
    } 

    const getTabCards = (currentTab) => {
        switch (currentTab) {
            case 0:
                return <OpenedBlock title={getTabTitle(selectedTab)}>
                    <div className='theme__cards' onScroll={disableScrolling}>
                        {allLessons.map((i, index) => (
                            <LessonCard key={index} completedTasks={i.completed_steps} totalTasks={i.total_steps} status={i.status} description={i.title} link={`/lesson/${i.id}`} />
                        ))}
                    </div>
                </OpenedBlock>


            case 1:
                return <OpenedBlock title={getTabTitle(selectedTab)} >
                    <div className='theme__cards' >
                        {currentTests.map((i, index) => (
                            <TaskCard key={index} title={i.title} description={i.description} data={i.data} progress={i.attempts_left ? `${i.attempts_left} попытки`: undefined} deadline={`${i.days_left} дней`} link={`/resource/${i.step_id}`} />
                        ))}
                    </div>
                </OpenedBlock>


            // case 2:
            //     return <div className='mainPageBlock__container'>
            //         <div className='mainPageBlock__header' >
            //             <div className='mainPageBlock__title'>{getTabTitle(selectedTab)}</div>
            //         </div>
            //         <div className='theme__cards' >
            //             {testsDone.map((i, index) => (
            //                 <TaskCard key={index} title={i.title} description={i.description} data={`${i.percent}%`} progress={`${i.used_attempts}/${i.allowed_attempts} попытки`} deadline={`${i.left_days} дней`}  link={`/resource/${i.step_id}`}/>
            //             ))}
            //         </div>
            //     </div>


            case 2:
                return <TableTests data={performance} sortTable={sortTable} />

            default:
                return ''
        }
    }

    const filterData = (id, model) => {
        console.log(id, model)
        api.getPerformanceSpecial(token, model, id)
            .then((res) => {
                // console.log(res)
                setPerformance(res)
            })
            .catch((e) => {
                console.log(e);
            });
    }
    const cleanFilter = (id, model) => {
        console.log('trying to clean filter to all lessons')
        api.getPerformanceSpecial(token, model, id)
            .then((res) => {
                // console.log(res)
                setPerformance(res)
                setIsLessonChecked(false)
                setCheckedId({ model: model, id: id })
            })
            .catch((e) => {
                console.log(e);
            });
    }

    const [tab, setTab] = useState(false)
    const [titleTag, setTitle] = useState('')
    const handleOpenTab = (title) => {
        if (title === 'Все курсы') {
            setTab(false)
            setTitle('_courses')
        } else if (title === 'Календарь') {
            setTab(true)
            setTitle('_calendar') 
        }
      }
      console.log(breadCrumbs)
    return (
       <>
        <div className='theme__container'>
        <div className='tab__wrap'>
              <div className={'tab__btn' + (titleTag ? titleTag === '_courses' : 'true')} onClick={() => handleOpenTab('Все курсы')}>Уроки</div>
              {/* <div className={'tab__btn' + (titleTag ? titleTag === '_calendar' : 'false')} onClick={() => handleOpenTab('Календарь')}>Календарь</div> */}
            </div>
            {tab && <div className='courses__calendar'><Calendar></Calendar></div>}
            {!tab && <div className='openedBlock__container'>
            {/* <div className='theme__leftColumn'>
                {defaultData.map((i, index) => (
                    <div key={index} className={`${selectedTab == index ? 'activeTab' : ''}`} onClick={() => setSelectedTab(index)}>{i}</div>
                ))}

            </div> */}
            {allDataReceived && <div className='theme__center'>
                <div className='theme__top'>
                    <div className='themeRoadMap__title'>{breadCrumbs.map((el) => el.type === 'theme' && el.title)}</div>
                    {/* <HorizontalTree type={'theme'} id={selectedThemeId} /> */}
                    {selectedTab === 2 &&
                        <div className='performance__filters'>

                            <div className={`performance__lessons  ${isLessonChecked ? 'filter_active' : ''}`} onClick={() => { setIsLessonsOpened(!isLessonsOpened); }}>Уроки
                                {isLessonsOpened &&
                                    <div className='filterMenu'>
                                        <div className='filterMenu__option'>
                                            <input type="radio" className="custom-radio" name="lessonFilter" onChange={() => { setIsLessonsOpened(false); cleanFilter(selectedThemeId, 'topic'); setIsLessonChecked(false); }} checked={checkedId.model === 'topic'} />
                                            <label htmlFor="lessonFilter">Все уроки</label>
                                        </div>
                                        {lessonSiblings.map((i, index) => (
                                            <div key={index} className='filterMenu__option'>
                                                <input type="radio" className="custom-radio" name="lessonFilter" id={i.id} onChange={(e) => { filterData(e.target.id, 'lesson'); setIsLessonChecked(true); setCheckedId({ model: 'lesson', id: e.target.id }) }} defaultChecked={checkedId.id == i.id} />
                                                <label htmlFor="lessonFilter">
                                                    <div className='filterMenu__text'>{i.title}</div>

                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                }
                            </div>
                        </div>}
                </div>
                {getTabCards(selectedTab)}
            </div>}
            </div>}
        </div>
       </>
    )
}
export default Theme
